$(document).ready(function () {
  if ($(".critical-notice").length > 0) {
    CloseNotice();
    /**
     * Animates the notice away and triggers ajax function to set session state to notice closed
     **/
    function CloseNotice() {
      var notice = $(".critical-notice");
      var absoluteBase = notice.attr("data-absolutebase");
      var currentLink = notice.attr("data-currentlink");

      if (currentLink == absoluteBase) {
        // if home page append /home/
        currentLink = absoluteBase + "home/";
      }

      var allowedAction = "setCriticalNoticeStateToClosed"; // function on PageController

      // on click of the close button
      notice.find(".critical-notice__close").on("click", function (evt) {
        // animate the notice away
        notice.slideUp();

        // fire ajax to call allowedAction to set session state to notice closed
        $.ajax({
          url: currentLink + allowedAction,
          type: "GET",
          data: {},
          response: function (response) {
            // console.log(response);
          },
        });
      });
    }
  }
});
